import i18n from "i18next"
import {initReactI18next} from "react-i18next";

import translationEn from './translation.en'
import translationKr from './translation.kr'
import translationJp from './translation.jp'



const resource =  {
    en: {
        translation: translationEn
    },
    kr: {
        translation: translationKr
    },
    jp: {
        translation: translationJp
    }
};

i18n
    .use(initReactI18next)  // passes i18n down to react-i18next
    .init({
        resources: resource,
        lng: "kr",
        fallbackLng: 'kr',
        // ns: ['translation'],
        // defaultNS: "translation",
        debug: true,
        keySeparator: ".", // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;